import * as svg from "../../../assets/checked-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const CheckedIcon = iconBuilder(svg, "CheckedIcon", "0 0 16 16");
